export enum ResponseCouponCodeEnum {
    createSuccess = 1000,
    existsCode = 1002,
    error = 1003,
    lengthCharactorError = 1004,
}